import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import HomeDiscover from '../components/home/HomeDiscover';
import HomeStories from '../components/storyComponents/HomeStories';
import HomeCategories from '../components/HomeCategories';
import HomeConnect from '../components/home/HomeConnect';
import HomeBannerSlider from '../components/homeBanner2/HomeBannerSlider';
import FeaturedOrgsSlider from '../components/featuredOrgsHomePage/FeaturedOrgsSlider';
import HomeNewsletter from '../components/home/HomeNewsletter/';
import HomeCollage from '../components/HomeCollage';

import {
  loadCollageOrganizations,
  loadHomeStories,
  loadFeaturedHomeOrganizations,
  loadBannerFeaturedOrgs,
  openSignupFormRequest,
  loadBFWOrganizations,
  loadFeaturedOrgsSlider
} from '../actions';


import Cookie from 'js-cookie'
import settings from '../settings';
import DocumentMeta from 'react-document-meta'
import Image from '../components/Image';
import FeaturedOrgs from '../components/featuredOrgsHomePage/FeaturedOrgs';

class Home extends Component {
  constructor(props) {
    super(props);

  }

  componentWillMount() {
    this.props.loadFeaturedHomeOrganizations();
    this.props.loadBannerFeaturedOrgs();
    this.props.loadBFWOrganizations({
      is_bfw_home: true
    });
    this.props.loadFeaturedOrgsSlider({
      limit: 12
    })
  }

  render() {

    const meta = {
      title: 'WorldWideWomen | The first-ever global resource center for women',
      description: "Check out WorldWideWomen, a global resource center for women and girls with listings on education, health, entertainment, financial planning, work, women’s rights.",
      canonical: 'https://worldwidewomen.co/',
      meta: {
        property: {
          'og:image': 'https://worldwidewomen.co/images/www_fb_logo.jpg'
        }
      },
      auto: {
        ograph: true,
      },
    }

    return (
      <div>
        <DocumentMeta {...meta} />

        <div className="content-wrapper">

          <HomeCollage 
              collageOrganizations={this.props.collageOrganizations}
              loadCollageOrganizations={this.props.loadCollageOrganizations}
              browser={this.props.browser}
              auth={this.props.auth}
              openSignupFormRequest={this.props.openSignupFormRequest}
            />

          <HomeCategories />
          <HomeNewsletter 
            user = {this.props.auth}
            openSignupFormRequest={this.props.openSignupFormRequest}
          />
          

          <HomeConnect
            user = {this.props.auth}
            openSignupFormRequest={this.props.openSignupFormRequest}
          />

          <div className="home-subHeader home-featured-orgs-header">
            <h3 className="section-title home-categoriesTitle home-searchTitle">Featured WorldWideWomen organizations</h3>
            <div className="section-description">Take a look at these amazing organizations from around the world and be inspired by their dedication to gender equality</div>
          </div>

          <FeaturedOrgsSlider
            browser = {this.props.browser}
            featuredOrgsSlider = {this.props.featuredOrgsSlider}
          />

          
          <HomeStories
            browser = {this.props.browser}
          />


        </div>
      </div>
      
    );


  }
};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    loadCollageOrganizations,
    loadFeaturedHomeOrganizations,
    loadBannerFeaturedOrgs,
    openSignupFormRequest,
    loadHomeStories,
    loadBFWOrganizations,
    loadFeaturedOrgsSlider
 })(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.jsx